import React, {useContext, useState} from "react";
import {toast} from "react-hot-toast";
import Select from "react-select";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxCallStation from "../../../util/remote/ajaxCallStation";

function AddSetting(props) {
  const [functionName, setFunctionName] = useState("");
  const [school, setSchool] = useState("");
  const [category, setCategory] = useState("");
  const {schoolList} = useContext(SchoolContext);
  const [loading2, setLoading2] = useState(false);

  const handleAdd = async (e) => {
    e.preventDefault();
      if (functionName.length > 0) {
        setLoading2(true)
        const server_response = await ajaxCallStation.createSetting(functionName, school);
        setLoading2(false)
        if (server_response.status === "OK") {
          toast.success(server_response.message);
          props.g();
          props.h();
          resetForm();
        } else {
          toast.error(server_response.message);
        }
      } else {
        toast.error("Please select a communication type!");
      }
    
  };

  const resetForm = () => {
    setFunctionName("");
    setCategory("");
    setSchool("");
  };

  return (
    <div className="card height-auto">
      <div className="card-body">
        <div className="heading-layout1">
          <div className="item-title">
            <h5 style={{marginBottom:0}}>Add Communication Setting</h5>
          </div>
        </div>
        <form
          onSubmit={(e) => handleAdd(e)}
          method="post"
          class="new-added-form">
          <div className="row">
            <div className="col-lg-12 col-12 form-group">
              <label htmlFor="">Setting Category <span style={{color:"red"}}>*</span> </label>
              <select className="col-12 form-control" value={category} style={{border: "1px solid grey"}} onChange={(e) => setCategory(e.target.value)}>
                <option value={true}>Select...</option>
                <option value="Global">Global Setting</option>
                <option value="School">School Setting</option>

              </select>
            </div>
            <div className="col-lg-12 col-12 form-group">
              <label htmlFor="">Communication Type <span style={{color:"red"}}>*</span> </label>
               <select
                    style={{border: "1px solid grey"}}
                    className="col-12 form-control"
                    value={functionName}
                    onChange={(e) => setFunctionName(e.target.value)}>
                    <option value="" selected disabled>Select communication type..</option>
                    <option value="Voice Call">Buzz Voice Calls</option>
                    <option value="Video Call">Buzz Video Calls</option>
                    <option value="Direct Call">Direct Calls</option>
                    <option value="Chat">Buzz Chats</option>
                    <option value="Voice Note">Buzz Voice Notes</option>
                    <option value="Direct Messages">Direct Messages</option>
                    <option value="Buzztime Requests">Buzztime Requests</option>
                    <option value="Pocketmoney Requests">Pocket Money Requests</option>


                </select>
            </div>
            {category === "School"? <div className="col-lg-12 col-12 form-group">
                <label htmlFor="">School <span style={{color:"red"}}>*</span></label>
                <Select
                  onChange={(e) => setSchool(e.school_id)}
                  getOptionLabel={(option) => option.school_name}
                  getOptionValue={(option) => option.school_id}
                  isSearchable
                  options={Array.isArray(schoolList) ? schoolList : []}
                  value={
                      Array.isArray(schoolList) &&
                      schoolList.find((value) => value.school_id === school)
                  }
                />
            </div>
            
            :""}
            
          </div>
          <div className="mt-5">
          {loading2 && (<button type="submit" className="col-xl-12 col-lg-12 col-12 btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue" disabled><i class="fa fa-spinner fa-spin mr-2"></i>Disabling...</button>)}
            {!loading2 && <button
              type="submit"
              className="col-xl-12 col-lg-12 col-12 btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue">
              Disable Communication
            </button>}
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddSetting;
